// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-alert-info{background-color:#c9dde8 !important;color:#2e586b !important}", "",{"version":3,"sources":["webpack://./src/pages/mybookings/BookingDetailsPage.scss"],"names":[],"mappings":"AAAA,mBACI,mCAAA,CACA,wBAAA","sourcesContent":[".custom-alert-info {\r\n    background-color: #C9DDE8 !important;\r\n    color: #2e586b !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
